import AxiosClient from "../api";
import { User } from "./types";

const fetchUser = async () => {
  try {
    const user = await AxiosClient.get("/auth/me");
    return user.data as User;
  } catch (error) {
    return null;
  }
};

const updateLanguage = async (lang: string) => {
  try {
    const response = await AxiosClient.put("/auth/me/language", { lang });
    return response.data;
  } catch (error) {
    console.error("Failed to update language:", error);
    throw error;
  }
};

export const UserService = {
  fetchUser,
  updateLanguage,
};
